import { FETCH_STORE_TEMP_SUCCESS, FETCH_STORE_TEMP_FAILURE, SAVE_STORE_TEMP_REQUEST } from "../../actions";
const initialState = {
    saveData: null,
    isLoading: false,
    error: null,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_STORE_TEMP_SUCCESS:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: null });
        case FETCH_STORE_TEMP_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case SAVE_STORE_TEMP_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null, saveData: action.payload });
        default:
            return state;
    }
};
export default reducer;
